/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { FormattedMessage } from 'js/lib/coursera.react-intl';

import { Grid, Typography2 } from '@coursera/cds-core';

import { CMLOrHTML } from 'bundles/cml';
import type { CmlContent } from 'bundles/cml';
import { isFeedbackOnOptionsEnabled } from 'bundles/grading-common';

import _t from 'i18n!nls/grading';

type Props = {
  suggestedScore: number;
  suggestedInputCml: string | CmlContent;
  feedback?: string | null;
};

const styles = {
  scoreLabelContainer: () => css`
    color: var(--cds-color-grey-600);
  `,
  feedbackContainer: () => css`
    margin-top: var(--cds-spacing-150);
  `,
};

const OptionsSuggestion = ({ suggestedScore, suggestedInputCml, feedback }: Props) => {
  const feedbackForOptionsEnabled = isFeedbackOnOptionsEnabled();
  return (
    <Grid item container xs={12} alignItems="center">
      <Grid item xs={12}>
        <Typography2 variant="subtitleMedium" component="span" color="inherit">
          <FormattedMessage
            message={_t(' {reviewPoints, plural, one {# point} other {# points}}')}
            reviewPoints={suggestedScore}
          />
        </Typography2>
      </Grid>
      <Grid item xs={12} css={styles.scoreLabelContainer}>
        <CMLOrHTML value={suggestedInputCml} />
      </Grid>
      {feedbackForOptionsEnabled && feedback && (
        <Grid item xs={12} css={styles.feedbackContainer}>
          <Typography2 component="p" color="inherit">
            {feedback}
          </Typography2>
        </Grid>
      )}
    </Grid>
  );
};

export default OptionsSuggestion;
